import React from 'react';

import { Spinner } from '../../../../components/Spinner';

export function LoadingState(): JSX.Element {
  return (
    <div className="flex justify-center items-center min-h-[200px]">
      <Spinner />
    </div>
  );
}
